/* Progressive enhancement: content and native disclosures work without JS. */
(() => {
  function enhanceArticle(article) {
    if (article.dataset.skReady) return;
    article.dataset.skReady = 'true';
    const content = article.querySelector('[data-sk-content]');
    if (!content) return;
    const sidebar = article.querySelector('[data-sk-sidebar]');
    const list = sidebar.querySelector('ol');
    const disclosure = sidebar.querySelector('details');
    const desktop = window.matchMedia('(min-width: 900px)');
    const syncDisclosure = () => { disclosure.open = desktop.matches; };
    syncDisclosure();
    desktop.addEventListener('change', syncDisclosure);
    article.addEventListener('sk:disconnect', () => desktop.removeEventListener('change', syncDisclosure), { once: true });
    const headings = [...content.querySelectorAll('h2')].filter(heading => !heading.closest('summary, [data-hf-author-card]'));
    const links = headings.map((heading, index) => {
      if (!heading.id) heading.id = `${article.id}-section-${index + 1}`;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim().replace(/\s*\([^)]*\)/g, '').split(':')[0];
      link.dataset.number = String(index + 1).padStart(2, '0');
      item.append(link);
      list.append(item);
      return link;
    });
    sidebar.hidden = !headings.length;
    article.classList.add('sk-article--enhanced');
    content.querySelectorAll('table').forEach((table, index) => {
      const wrapper = document.createElement('div');
      wrapper.className = 'sk-article__table-scroll';
      wrapper.tabIndex = 0;
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', `Article comparison table ${index + 1}; scroll horizontally to see all columns`);
      table.before(wrapper);
      wrapper.append(table);
    });
    if (headings.length && 'IntersectionObserver' in window) {
      const setActive = heading => links.forEach((link, index) => {
        if (headings[index] === heading) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
      const observer = new IntersectionObserver(entries => {
        const entered = entries.filter(entry => entry.isIntersecting);
        if (entered.length) setActive(entered[0].target);
      }, { rootMargin: '-100px 0px -55% 0px', threshold: 0 });
      headings.forEach(heading => observer.observe(heading));
      links.forEach((link, index) => link.addEventListener('click', () => setActive(headings[index])));
      article.addEventListener('sk:disconnect', () => observer.disconnect(), { once: true });
    }
  }
  document.querySelectorAll('[data-sk-article]').forEach(enhanceArticle);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-sk-article]').forEach(enhanceArticle));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-sk-article]').forEach(article => article.dispatchEvent(new Event('sk:disconnect'))));
})();
